module.exports = __webpack_public_path__ + "img/ACB.f1589a79.svg";